<template>
  <section class="container p-4">
    <div class="row" v-if="preQrPayment !== null">
      <div class="col-lg-6 offset-lg-3">
        <div v-if="preQrPayment && !preQrPayment.paid_status">
          <div class="text-center" v-if="isExpiredPayment()">
            <div class="text-center pb-3">
              <i class="fal fa-times-circle text-danger fa-3x"></i>
            </div>
            <div class="pb-3">ไม่สามารถดำเนินการชำระเงินได้ เนื่องจากเลยระยะเวลาการทำรายการ
              กรุณาติดต่อแอดมินเพื่อช่วยประสานงาน
            </div>
            <a href="https://line.me/R/ti/p/%40hnk7011n"
               class="btn btn-info btn-block"
               target="_blank">{{ $t('message.button.contact_admin') }}</a>
          </div>
          <div v-else>
            <div class="text-center">
              กรุณาดำเนินการชำระเงินภายใน {{ paymentDate | prettyDate }}
            </div>
            <qr-code-payment ref="qrCodePayment" @checkQrPayment="checkQrPayment"/>
          </div>
        </div>
        <div class="text-center" v-else>
          <div class="mb-4">
            <i class="fas fa-check-circle fa-5x -status-accepted"></i>
          </div>
          <h2>{{ $t('message.qr_payment.payment_successful') }}</h2>
        </div>
      </div>
    </div>
    <div class="text-center" v-else>
      <div class="mb-4">
        <i class="fas fa-times-circle fa-5x -status-alert"></i>
      </div>
      <h2>ไม่สามารถดำเนินการชำระเงินได้<br>เนื่องจากไม่มีข้อมูลธุรกรรมในระบบ</h2>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import QrCodePayment from '../qrPayment/QrCodePayment'
  import axios from 'axios'
  import moment from 'moment-timezone'

  export default {
    components: {
      QrCodePayment
    },
    data () {
      return {
        checkingQrPayment: null,
        queryParams: null,
        preQrPayment: null,
        qrResponse: null,
        paymentDate: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      ...mapActions('auth', ['getToken']),
      isExpiredPayment () {
        const currentTime = moment()
        const cleaningTime = moment(this.preQrPayment.created_at)
        const duration = moment.duration(currentTime.diff(cleaningTime))
        const diffMins = Math.round(duration.asMinutes())
        return diffMins > 165
      },
      checkQrPayment (response) {
        this.qrResponse = response
        // Clear old interval before starting a new one
        if (this.checkingQrPayment !== null) {
          clearInterval(this.checkingQrPayment)
          this.checkingQrPayment = null
        }
        this.checkingQrPayment = setInterval(() => {
          const url = '/qr-payments'
          axios.get(url, {params: {transaction_code: this.qrResponse.partnerTxnUid}})
            .then(res => {
              const response = res.data
              if (!response.error) {
                if (response.qr_payment && response.qr_payment.status_code) {
                  if (response.qr_payment.status_code === '00') {
                    clearInterval(this.checkingQrPayment)
                    // Update paid data
                    this.validatePreQrPayment()
                    // Scroll to top
                    document.body.scrollTop = 0
                    document.documentElement.scrollTop = 0
                  } else if (response.qr_payment.status_code === '10') {
                    clearInterval(this.checkingQrPayment)
                    const alertMessage = `Error: ${response.qr_payment.error_description}`
                    this.$swal({text: alertMessage, type: 'error'})
                    // if error set qr code timeout to be expired
                    this.$refs.qrCodePayment.finishTimer()
                  }
                }
              } else {
                clearInterval(this.checkingQrPayment)
              }
            })
            .catch(error => {
              console.log('error', error)
            })
        }, 7000)
      },
      async validatePreQrPayment () {
        const params = {
          id: this.queryParams.id,
          validation: this.queryParams.validation
        }
        const url = `/pre-qr-payments/validation`
        const res = await axios.post(url, params)
        if (res.status === 200) {
          const response = res.data
          if (!response.error) {
            this.preQrPayment = response.pre_qr_payment
            const date = moment(this.preQrPayment.created_at, 'YYYY-MM-DD HH:mm:ss')
            this.paymentDate = date.add(165, 'minutes').format('YYYY-MM-DD HH:mm:ss')
            if (this.preQrPayment && !this.preQrPayment.paid_status && !this.isExpiredPayment()) {
              let amount = this.preQrPayment.amount
              // Check withholding tax to re-calculate amount
              if (this.preQrPayment.withholding_tax_amount) {
                amount = this.preQrPayment.amount - this.preQrPayment.withholding_tax_amount
              }
              const qrPaymentData = {
                paymentFor: 'normal',
                preQrPaymentId: this.preQrPayment.id,
                amount: Number(amount),
                user: (this.preQrPayment.user) ? this.preQrPayment.user : null,
                professionalRegisterPayment: (this.preQrPayment.professional_register_payment) ? this.preQrPayment.professional_register_payment : null
              }
              setTimeout(() => {
                this.$refs.qrCodePayment.loadQrCode(qrPaymentData)
              }, 1000)
            }
          }
        }
      }
    },
    beforeDestroy () {
      clearInterval(this.checkingQrPayment)
    },
    async mounted () {
      this.queryParams = this.$route.query
      if (this.queryParams) {
        if (!this.user) {
          const submitData = {
            pre_qr_payment_id: this.queryParams.id,
            validation: this.queryParams.validation
          }
          await this.getToken(submitData)
        }
        await this.validatePreQrPayment()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/qrPayment/PreQrPayment.vue